import { render, staticRenderFns } from "./ArtikelRow.vue?vue&type=template&id=6fffa791"
import script from "./ArtikelRow.vue?vue&type=script&lang=ts"
export * from "./ArtikelRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports